module.exports = __webpack_public_path__ + "img/icon-ethereum.6b4873c1.svg";